// tslint:disable:no-empty-interface
import { ISubCategories, ISubcategorySettings } from '@valhalla/data/entities';
import { Observable } from 'rxjs';

export abstract class CategoryDataHttpService {
	abstract selectCatSubcat(settings: ISelectCategoryCriteria): Observable<ICategoryItem[]>;
	abstract storageSubCategory(subcatId: number): Observable<ISubCategories>;
	abstract subcategoriesTree(): Observable<ISubategoriesTree>;
	abstract subcategoryStates(subcatId: number): Observable<IGetSubcategoryStatesResult>;
	abstract dataSourceConfig(subcatId: number): Observable<IGetDataSourceConfigResult>;
	abstract dataSourceRows(subcatId: number, params: any): Observable<any>;
	abstract dataSourceSaveSettings(params: IDataSourceSaveSettingsParams): Observable<any>;
	abstract smartExpressions(criteria: IDataSourceGetSmartExpressions): Observable<any[]>;
	abstract updateSubcategorySettings(criteria: ISubcategorySettings, subcatId: number): Observable<any>;
}

export interface IDataSourceGetSmartExpressions {
	subcatId?: number;
}

export interface IDataSourceSaveSettingsParams {
	entityId: number;
	clientSettings: any;
	isAdmin?: boolean;
	userId?: number;
	key?: string;
	type?: string;
	settingName?: string;
}

export interface IGetDataSourceConfigResult {
	/**
	 * Набор доступных колонок для грида
	 */
	taskColumnsSettings: any[];

	/**
	 * Админсикие настройки стейта грида
	 */
	adminColumnsSettings?: any;

	/**
	 * Сохраненный стейт грида юзера
	 */
	userColumnsSettings?: any;
}

export interface IGetSubcategoryStatesResult {
	data: Array<{
		isActive: boolean;
		name: string;
		id: number;
	}>;
	total: number;
	aggregates?: any;
}

export interface ISelectCategoryCriteria {
	criteria: ICriteria;
	displaySettings: IDisplaySettings;
}

export interface IDisplaySettings {
	allowMultipleSelect: boolean;
	readOnly: boolean;
}

export interface ICriteria {
	criteriaType: ICriteriaType;
}

export interface ICategoryItem {
	id: number;
	text: string;
	parentId?: number;
	type: ICategoryType;
	hasChildren?: boolean;
	items?: ICategoryItem[];
	state?: string;
	isExpand?: boolean;
	isHide?: boolean;
	accent?: boolean;
}

export enum ICategoryType {
	category = 'Category',
	subcategory = 'Subcategory',
}

export enum ICriteriaType {
	searchCriteria = 'SearchCriteria',
}

export interface ISubategoriesTreeTasksCounters {
	allTasksCount: number;
	newTasksCount: number;
	overdueTasksCount: number;
	allTasksUserOwns: number;
	allTasksUserPerforms: number;
}

export interface ISubategoriesTreeDatum {
	tasksCounters: ISubategoriesTreeTasksCounters;
	parentId: number;
	nodeType: string;
	isDictionary: boolean;
	canEdit: boolean;
	openType: string;
	portalId: number;
	canCreateTask: boolean;
	name: string;
	id: number;
}

export interface ISubategoriesTreeAggregates {}

export interface ISubategoriesTree {
	data: ISubategoriesTreeDatum[];
	total: number;
	aggregates: ISubategoriesTreeAggregates | null;
}
